import { useState, useEffect } from 'react';
import NeoCard from 'design/design_components/neo/panel/NeoCard.base';
import NeoInputText from 'design/design_components/neo/form/NeoInputText.base';
import NeoInnerTitle from 'design/design_components/neo/title/NeoInnerTitle.base';
import NeoInnerSubtitle from "design/design_components/neo/title/NeoInnerSubtitle.base";
import templatesUtil from 'utils/templates.util';
import NeoInputGroup from 'design/design_components/neo/form/NeoInputGroup.base';

export default function TemplateStructureVariablesForm(props) {
  const [headerType, setHeaderType] = useState();
  const [headerParam, setHeaderParam] = useState();
  const [bodyParams, setBodyParams] = useState([]);
  const [buttonsParams, setButtonsParams] = useState([]);

  useEffect(() => reboot(), [props.structure]);

  useEffect(() => {
    let isValid = true;
    if(isValid && headerParam) {
      isValid = headerParam?.value.trim().length > 0;
    }
    if(isValid && Array.isArray(bodyParams)) {
      isValid = bodyParams.reduce((isValid, param) => {
        if(isValid) {
          return param.value.trim().length > 0;
        }
        return false;
      }, isValid)
    }
    if(isValid && Array.isArray(buttonsParams)) {
      isValid = buttonsParams.reduce((isValid, param) => {
        if(isValid) {
          return param.value.trim().length > 0;
        }
        return false;
      }, isValid)
    }
    if(typeof props?.onChangeValidate === "function") {
      props.onChangeValidate(isValid);
    }
  }, [headerParam, bodyParams, buttonsParams])

  const reboot = () => {
    getHeaderParam();
    getBodyParams();
    getButtonsParams();
  }

  const getHeaderParam = () => {
    let paramObject = undefined;
    const type = props.structure?.header?.type;
    if (type == 'TEXT') {
      const [paramName] = props.structure.header.text.match(/\{\{[_0-9a-zA-Z]+\}\}/g) ?? [];
      if (paramName) {
        paramObject = { name: paramName, value: '' };
      }
    }
    else if (type) {
      paramObject = { name: 'url', value: '' };
    }
    setHeaderType(type);
    setHeaderParam(paramObject);
  }

  const getBodyParams = () => {
    const paramsNames = props.structure?.body?.match(/\{\{[_0-9a-zA-Z]+\}\}/g) ?? [];
    const paramsObjects = paramsNames.map((paramName) => ({ name: paramName, value: '' }));
    setBodyParams(paramsObjects);
  }

  const getButtonsParams = () => {
    const paramsNames = props.structure?.buttons?.reduce((paramsNames, button, index) => {
      if(button.type === "URL") {
        const params = button.url.match(/\{\{[_0-9a-zA-Z]+\}\}/g);
        if(Array.isArray(params)) {
          const [url] = params;
          if(url) paramsNames[index] = url;
        }
      }
      return paramsNames;
    }, []) ?? [];
    const paramsObjects = paramsNames.reduce((paramsObjects, paramName, index) => {
      const param = {name: paramName, value: ""};
      const button = props.structure.buttons[index];
      if(button.type === "URL") {
        const indexParam = button.url.indexOf(param.name);
        if(indexParam > 0) {
          param.initialUrl = button.url.slice(0, indexParam);
        }
      }
      paramsObjects[index] = param;
      return paramsObjects;
    }, []);
    setButtonsParams(paramsObjects);
  }

  const handleHeaderParamChange = (event) => {
    const updatedHeaderParam = { ...headerParam };
    const value = event.value ?? event.target.value;
    updatedHeaderParam.value = value;
    setHeaderParam(updatedHeaderParam);
    props.onChange({ header: updatedHeaderParam });
  }

  const handleBodyParamChange = (index, event) => {
    const value = event.value ?? event.target.value;
    const updatedBodyParams = [...bodyParams];
    updatedBodyParams[index].value = value;
    setBodyParams(updatedBodyParams);
    props.onChange({ body: updatedBodyParams });
  }

  const handleButtonsParamChange = (index, event) => {
    const value = event.value ?? event.target.value;
    const updatedButtonsParams = [...buttonsParams];
    updatedButtonsParams[index].value = value;
    setButtonsParams(updatedButtonsParams);
    props.onChange({ buttons: updatedButtonsParams });
  }

  return (
    <NeoCard>
      <NeoInnerTitle extra="primero">Valores para su aprobación en Facebook</NeoInnerTitle>
      {
        (!headerParam && bodyParams.length == 0) &&
        <NeoInnerSubtitle>La plantilla no tiene variables.</NeoInnerSubtitle>
      }
      {
        (headerParam) &&
        <>
          <NeoInnerSubtitle>Encabezado</NeoInnerSubtitle>
          <NeoInputText
            label={headerType == 'TEXT' ? headerParam.name : `Url de ${templatesUtil.getTemplateHeaderType(headerType)}`}
            value={headerParam.value}
            onChange={handleHeaderParamChange}
          />
        </>
      }
      {
        (bodyParams.length > 0) &&
        <>
          <NeoInnerSubtitle>Cuerpo</NeoInnerSubtitle>
          {
            bodyParams.map((bodyParam, index) => (
              <NeoInputText
                col="12"
                key={index}
                label={bodyParam.name}
                value={bodyParam.value}
                onChange={(event) => handleBodyParamChange(index, event)}
              />
            ))
          }
        </>
      }
      {
        (buttonsParams.length > 0) &&
        <>
          <NeoInnerSubtitle>Botones</NeoInnerSubtitle>
          {
            buttonsParams.map((buttonParam, index) => (<>
              <label>"{props?.structure?.buttons[index]?.text}"</label>
              <NeoInputGroup 
                label={buttonParam.initialUrl} 
                title={buttonParam.initialUrl}
                type="TEXT"
                inputValue={buttonParam.value}
                inputOnChange={(event) => handleButtonsParamChange(index, event)}
                inputLabel={buttonParam.name}
                className={"inputgroup-link"}
                key={index}
              />
            </>))
          }
        </>
      }
    </NeoCard>
  );
}
